import gsap from 'gsap';

const selectors = {
    banner: '.js-announcement',
    close: '.js-announcement-close'
};

let bannerHeight;
let previousHeight = window.parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--bannerHeight'));

const updateBannerHeight = (banner, previousHeight) => {
    const heightDelta = bannerHeight - banner.offsetHeight;
    document.documentElement.style.setProperty('--bannerHeight', previousHeight - heightDelta + 'px');
};

const close = banner => {
    previousHeight = window.parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--bannerHeight'));

    gsap.to(banner, {
        height: 0,
        duration: 0.3,
        ease: 'power2.out',
        onUpdate: updateBannerHeight,
        onUpdateParams: [banner, previousHeight],
        onComplete: () => {
            banner.remove();
            dispatchEvent(new CustomEvent('domUpdated'));
            document.cookie = "announcement_closed=true; Secure";
        }
    });
};

const build = banner => {
    const closeBtn = banner.querySelector(selectors.close);
    bannerHeight = banner.offsetHeight;

    const bannerWasClosed = document.cookie.includes('announcement_closed=true');

    if (bannerWasClosed) {
        banner.remove();
        return;
    }

    document.documentElement.style.setProperty('--bannerHeight', bannerHeight + 'px');

    closeBtn.addEventListener('click', () => {
        close(banner);
    });
};

const init = () => {
    const banner = document.querySelector(selectors.banner);

    if (!banner) return;

    build(banner);
};

export default init;
